import { render, staticRenderFns } from "./TransactionListQA.vue?vue&type=template&id=6b4a0851&scoped=true"
import script from "./TransactionListQA.vue?vue&type=script&lang=js"
export * from "./TransactionListQA.vue?vue&type=script&lang=js"
import style0 from "./TransactionListQA.vue?vue&type=style&index=0&id=6b4a0851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a0851",
  null
  
)

export default component.exports